/**
 * Clamp a score between 0 and 100, preserving "not measured" as null.
 *
 * `null` means NOT MEASURED — distinct from 0, which would mean "measured, and
 * bad". Coercing a missing value to 0 rendered an unmeasured dimension to the
 * user as a 0% bar, which is fabrication.
 *
 * (Formerly exported from hooks/useRealTimeScoring, a hook that existed only to
 * relay scores from the removed legacy live-voice socket.)
 */
export function clampOrNull(value?: number | null): number | null {
  if (value === null || value === undefined || !Number.isFinite(value)) return null;
  return Math.min(100, Math.max(0, value));
}

/**
 * A 0-1 rate as a whole percentage, or "—" when there is no rate (null /
 * undefined, e.g. a completion rate with no assignments). 0 renders "0%"
 * only when it truly is zero.
 */
export function formatRate(rate?: number | null): string {
  if (rate === null || rate === undefined || !Number.isFinite(rate)) return '—';
  return `${(rate * 100).toFixed(0)}%`;
}
